import React from "react";

const COLOR_MAP = {
    indigo: { bg: "bg-indigo-50", icon: "text-indigo-600", accent: "border-indigo-500" },
    blue: { bg: "bg-sky-50", icon: "text-sky-600", accent: "border-sky-500" },
    green: { bg: "bg-emerald-50", icon: "text-emerald-600", accent: "border-emerald-500" },
    orange: { bg: "bg-amber-50", icon: "text-amber-600", accent: "border-amber-500" },
    emerald: { bg: "bg-teal-50", icon: "text-teal-600", accent: "border-teal-500" },
    rose: { bg: "bg-rose-50", icon: "text-rose-600", accent: "border-rose-500" },
    violet: { bg: "bg-violet-50", icon: "text-violet-600", accent: "border-violet-500" },
};

const AnalyticsMiniCard = ({
    title,
    value,
    icon,
    color = "indigo",
}) => {
    const theme = COLOR_MAP[color] || COLOR_MAP.indigo;

    return (
        <div className={`flex items-center gap-3 rounded-lg border-l-4 ${theme.accent} bg-white p-3 shadow-sm ring-1 ring-slate-100 transition-shadow duration-200 hover:shadow-md`}>
            <div className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${theme.bg} ${theme.icon}`}>
                <div className="text-base">{icon}</div>
            </div>

            <div className="min-w-0 flex-1">
                <div className="truncate text-base font-bold tabular-nums text-slate-900">
                    {value || "-"}
                </div>
                <div className="truncate text-[11px] uppercase tracking-wide text-slate-500">
                    {title}
                </div>
            </div>
        </div>
    );
};

export default AnalyticsMiniCard;